export const SYSTEM = {
  VERSION: import.meta.env.VITE_VERSION as string,
  REALM: import.meta.env.VITE_REALM as string,
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
  API_URL: import.meta.env.VITE_API_URL as string,
  API_HOST: import.meta.env.VITE_API_HOST as string,
  TRANSLATION_S3_URL: import.meta.env.VITE_TRANSLATION_S3_URL as string,
};
